import Hero from './Hero';
import InfoSection from './InfoSection';
import SEOHelmet from './SEOHelmet';

function HomePage() {
  return (
    <>
      <SEOHelmet
        title="Torque Energy - Premium Energy Drinks for Peak Performance"
        description="Torque Energy delivers clean, sustained energy without the crash. Premium energy drinks crafted with natural ingredients to fuel your ambition, enhance focus, and boost performance. Drive Your Day!"
        keywords="energy drinks, torque energy, clean energy, performance drinks, natural energy, focus boost, sustained energy, no crash, premium energy drinks, fitness drinks"
        url="https://torqueenergy.shop/"
      />
      <div className="container">
        <Hero />
        <InfoSection />
      </div>
    </>
  );
}

export default HomePage;